import { render } from "./Providers.vue?vue&type=template&id=38abc84c&scoped=true"
const script = {}

import "./Providers.vue?vue&type=style&index=0&id=38abc84c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38abc84c"]])

export default __exports__